var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E0621E",
    d: "M8 0h2v18H8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0621E",
    d: "M18 8v2H0V8z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjgiIHdpZHRoPSIyIiBoZWlnaHQ9IjE4IiBmaWxsPSIjRTA2MjFFIi8+CiAgICA8cmVjdCB4PSIxOCIgeT0iOCIgd2lkdGg9IjIiIGhlaWdodD0iMTgiIHRyYW5zZm9ybT0icm90YXRlKDkwIDE4IDgpIiBmaWxsPSIjRTA2MjFFIi8+Cjwvc3ZnPgo=";
export { SvgPlusIcon as ReactComponent };